import React from 'react';
import ContentContainer from "../ReusableComponents/ContentContainer/ContentContainer"
import ServiceCard from "../ReusableComponents/ImageLinkCard/ImageLinkCard";
import styles from "./HomeServicesSection.module.css";
import { useTheme } from "../../hooks/useTheme";
import { cardsData } from "../../jsonData/data";

const HomeServicesSection = () => {
  const theme = useTheme();

  // Using the new theme system
  const headerStyle = {
    fontFamily: theme.typography.fonts.primary,
    fontSize: theme.typography.fontSizes["4xl"],
    fontWeight: theme.typography.fontWeights.medium,
    color: theme.colors.primary[500],
    margin: `${theme.spacing[2]} 0`,
  };

  const descriptionStyle = {
    fontFamily: theme.typography.fonts.secondary,
    fontSize: theme.typography.fontSizes.lg,
    fontWeight: theme.typography.fontWeights.normal,
    color: theme.colors.neutral[600],
    lineHeight: theme.typography.lineHeights.relaxed,
  };

  const cardsContainerStyle = {
    fontFamily: theme.typography.fonts.primary,
    gap: theme.spacing[6],
    padding: theme.spacing[4],
  };

  return (
    <ContentContainer>
      <div
        id="services"
        data-testid="HomeServicesSection"
        className={styles.HomeServicesSection}
        style={{
          paddingTop: theme.spacing[24],
        }}
      >
        <div className={styles.header}>
          <h4 style={headerStyle}>Our Services</h4>
          <p style={descriptionStyle}>
            We provide the best available choices for you. Adjust these
            according to your needs and leave the rest to us! Our expertise in
            infrastructure-as-code can help you replicate your products
            architecture without any manual labour.
          </p>
        </div>
        <div className={styles.cards} style={cardsContainerStyle}>
          {cardsData.map((card, index) => (
            <ServiceCard key={index} {...card} className={styles.imageCards} />
          ))}
        </div>
      </div>
    </ContentContainer>
  );
};

export default HomeServicesSection;
